import { createAction, createNetworkActions } from "~/utils/actions";

export default {
	...createNetworkActions("DOKUMENTER_NYE"),
	...createNetworkActions("DOKUMENTER_GAMLE"),
	...createAction("SET_LEST"),
	...createAction("DOKUMENTER_SAVE_SCROLL"),
	...createAction("DOKUMENTER_DELETE_SCROLL"),
};
